module.exports = __webpack_public_path__ + "static/img/img04@2x.ef688a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/instructions/img04@2x.png
// module id = OQnm
// module chunks = 174